import React, {memo, useCallback, useMemo, useState} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {useSelector} from "react-redux"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useLocalization} from "../../../../hooks/localization"
import {AuthorityModel} from "../../../../store/control/state"

const keyExtractor = (item: AuthorityModel) => item.id
export const AuthorizationGroupList = memo(function AuthorizationGroupList() {
    const authorityGroupList = useSelector(state => state.control.authorityGroupList)
    const {t} = useLocalization()
    const [selectedGroup, setSelectedGroup] = useState<AuthorityModel>(null)
    const buttons = useMemo(
        () => [
            {
                text: t("authority.overview_list"),
                url: "/settings/authority/user-list",
                className: "yellow"
            },
            {
                text: t("authority.add_new_user"),
                url: `/settings/authority/add-user/${selectedGroup ? selectedGroup.id : ""}`,
                className: "blue",
                hidden: !selectedGroup
            },
            {
                text: t("edit"),
                url: `/settings/authority/edit/${selectedGroup ? selectedGroup.id : ""}`,
                className: "orange",
                hidden: !selectedGroup
            },
            {
                text: t("authority.create_auth_group"),
                url: "/settings/authority/edit",
                className: "green"
            }
        ],
        [t, selectedGroup]
    )

    const displayNameExtractor = useCallback((item: AuthorityModel, column: ColumnModel) => {
        if (column.key === "name") {
            return item.name
        }
        return item[column.key] || "-"
    }, [])

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 3,
                name: t("name"),
                key: "name"
            }
        ],
        [t]
    )

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="camera-list-page" backUrl={"/settings"}>
                <SettingsList
                    columns={columns}
                    items={authorityGroupList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedGroup}
                    onItemSelected={setSelectedGroup}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
